// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.akEeNi {
  margin-bottom: 24px;
}

.hSWWZR {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 768px) {
  .hSWWZR {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1200px) {
  .hSWWZR {
    grid-template-columns: repeat(3, 1fr);
  }
}

.xPU0IC {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  flex: 1;
  min-height: 104px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #e5e5e5);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  gap: 16px;
}

.xPU0IC:hover {
  background: var(--surface-primary-hover, #f5f5f5);
  transform: translateY(-2px);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
}

.PtxSPZ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: transparent;
}

.KcEbrE {
  width: 16px;
  height: 16px;
  color: var(--brand-primary, #d64000);
}

.Xmio5X {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--text-primary, #1f1f1f);
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  margin: 0;
}

/* Tablet styles */
@media (max-width: 768px) {
  .xPU0IC {
    width: 160px;
    min-height: 96px;
    padding: 14px;
    gap: 14px;
  }
}

/* Mobile styles */
@media (max-width: 480px) {
  .xPU0IC {
    width: 100%;
    min-height: 88px;
    padding: 12px;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/QuickActions/QuickActions.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;AACF","sourcesContent":[".container {\n  margin-bottom: 24px;\n}\n\n.actionsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n@media (min-width: 768px) {\n  .actionsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1200px) {\n  .actionsGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.actionCard {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px;\n  flex: 1;\n  min-height: 104px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #e5e5e5);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);\n  box-sizing: border-box;\n  gap: 16px;\n}\n\n.actionCard:hover {\n  background: var(--surface-primary-hover, #f5f5f5);\n  transform: translateY(-2px);\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  background: transparent;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  color: var(--brand-primary, #d64000);\n}\n\n.title {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: var(--text-primary, #1f1f1f);\n  text-align: left;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  margin: 0;\n}\n\n/* Tablet styles */\n@media (max-width: 768px) {\n  .actionCard {\n    width: 160px;\n    min-height: 96px;\n    padding: 14px;\n    gap: 14px;\n  }\n}\n\n/* Mobile styles */\n@media (max-width: 480px) {\n  .actionCard {\n    width: 100%;\n    min-height: 88px;\n    padding: 12px;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `akEeNi`,
	"actionsGrid": `hSWWZR`,
	"actionCard": `xPU0IC`,
	"iconContainer": `PtxSPZ`,
	"icon": `KcEbrE`,
	"title": `Xmio5X`
};
module.exports = ___CSS_LOADER_EXPORT___;
